import PropTypes from 'prop-types';
const socialItemPropShape = PropTypes.shape({
  icon: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string
});
export const socialsBarPropTypes = {
  socials: PropTypes.arrayOf(socialItemPropShape),
  isMobileOpen: PropTypes.bool
};